var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-12"},[_c('v-row',_vm._l((_vm.components),function(item){return _c('v-col',{key:item.id,attrs:{"cols":"12"}},[_c(item,{tag:"component"})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }